// extracted by mini-css-extract-plugin
export default {"knowContainer":"styles_knowContainer__oQm2r","VR1Variants":"styles_VR1Variants__ESr3q","variantsInner":"styles_variantsInner__RzCH-"};